<template>
	<div>
		<div class="pt-2 ps-4">
			<b-search
				v-model="search"
				class="mb-1"
				:bones="searchItems"
				@search="fetch"
				@clear="fetch"></b-search>
		</div>
		<v-divider></v-divider>
		<v-tabs v-model="tabs">
			<v-tab :to="{ name: 'employee-work', query: { employeeId: $route.query.employeeId } }">
				<v-icon class="me-1"> mdi-calendar-check </v-icon>
				{{ $T('tabs.work') }}
			</v-tab>
			<v-tab :to="{ name: 'employee-vacation', query: { employeeId: $route.query.employeeId } }">
				<v-icon class="me-1"> mdi-calendar-alert </v-icon>
				{{ $T('tabs.vacation') }}
			</v-tab>
			<v-tab :to="{ name: 'employee-permission', query: { employeeId: $route.query.employeeId } }">
				<v-icon class="me-1"> mdi-calendar-clock </v-icon>
				{{ $T('tabs.permissions') }}
			</v-tab>
			<v-tab :to="{ name: 'employee-mission', query: { employeeId: $route.query.employeeId } }">
				<v-icon class="me-1"> mdi-calendar-star </v-icon>
				{{ $T('tabs.mission') }}
			</v-tab>
		</v-tabs>
		<v-divider></v-divider>

		<router-view
			v-if="search"
			ref="child"
			:search="search"
			:employee="employee"
			:employee-id="employeeId"
			:loading-fetch-employee="loadingFetchEmployee"
			@fetch-employee="$emit('fetch-employee')"></router-view>
	</div>
</template>
<script>
export default {
	name: 'Attendance',

	props: {
		employee: { type: Object },
		employeeId: { type: String },
		loadingFetchEmployee: { type: Boolean },
	},

	data() {
		return {
			tabs: null,
			search: null,

			searchItems: [
				{
					type: 'toggle',
					value: 'toggle',
					items: [
						{
							name: 'مدة',
							for: ['DateTo', 'DateFrom'],
						},
						{
							name: 'يومي',
							for: ['Date'],
						},
					],
				},
				{
					type: 'from_date',
					value: 'DateFrom',
					toggle: 'toggle',
				},
				{
					type: 'to_date',
					value: 'DateTo',
					toggle: 'toggle',
				},
				{
					type: 'switch_date',
					value: 'Date',
					toggle: 'toggle',
					valuesAs: ['DateFrom', 'DateTo'],
				},
			],
		};
	},

	methods: {
		fetch(params) {
			this.$refs.child.fetch(params);
		},
	},
};
</script>
